export default "__VITE_ASSET__CocD2mWf__"